import { render, staticRenderFns } from "./spectrum.vue?vue&type=template&id=5265f74a&scoped=true&"
import script from "./spectrum.vue?vue&type=script&lang=js&"
export * from "./spectrum.vue?vue&type=script&lang=js&"
import style0 from "./spectrum.vue?vue&type=style&index=0&id=5265f74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265f74a",
  null
  
)

export default component.exports